<template>
  <div class="rights">
    <ul>
      <li
        v-for="(item, i) in parts"
        :key="i"
        v-if="item.items && item.items.length"
      >
        <div class="title">
          <span class="title-text" @click="toggleFold(item)">
            <span class="bold">{{ item.title }}</span>
            <span
              v-html="getFoldTitle((item.items || []).length, item.title)"
            ></span>
            <i class="title-arrow" :class="{ active: item.foldOpened }"></i>
          </span>
          <div class="title-btn" @click="goPopMsg(item.name)">
            {{ item.btnText }}
          </div>
        </div>
        <div class="panel" :class="{ opened: item.foldOpened }">
          <div class="risk-item" v-for="(riskItem, j) in item.items" :key="j">
            <RiskItem
              :info="riskItem"
              :ref="item.name + 'Ref'"
              :needAction="needAction"
              @onRemove="onRemoveItem"
            ></RiskItem>
          </div>
        </div>
      </li>
    </ul>
    <div v-if="isEmpty()" class="empty">
      <div class="figure">
        <img src="../../../assets/risk/commercial.png" alt="" />
      </div>
      <div class="text">当前素材使用权均可使用</div>
    </div>
    <div class="shim"></div>
    <div class="upgrade" @click="buyVip">
      {{
        UserLevelType == 3
          ? "已解锁全站商用素材"
          : "升级为Pro+版会员解锁全站商用素材"
      }}
    </div>
  </div>
</template>

<script>
import { mapGetters,mapMutations } from "vuex";
import RiskItem from "./riskItem";
import { getVipList as getVipSceneEffects, isNeedVIP } from './sceneEffectTypes.js';
export default {
  components: {
    RiskItem,
  },
  props: {
    needAction: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      parts: [
        {
          name: "vip",
          title: "会员专属素材 - ",
          btnText: "升级会员",
          items: [],
          foldOpened: true,
        },
        {
          name: "pay",
          title: "付费购买素材 - ",
          btnText: "付费购买",
          items: [],
          foldOpened: true,
        },
        {
          name: "abandon",
          title: "过期下架素材 - ",
          btnText: "一键删除",
          items: [],
          foldOpened: true,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "IsVipSprites",
      "TOOL",
      "UserEquity",
      "UserMsg",
      "UserLevelType",
      'isPoor'
    ]),
  },
  watch: {
    "IsVipSprites.data"(val = []) {
      this.classifyItems(val);
    },
  },
  created() {
    this.classifyItems(this.IsVipSprites.data);
    this.$bus.on("rmAbandon", this.rmAbandon);
    eve.on('scene.effectUpdated', ({code, manual}) => {
      if (this.isPoor && isNeedVIP(code) && manual) {
        const isToastInView = $(".vip-toast").length;
        isToastInView ||
          this.$message({
            showClose: true,
            message:
              "您正在使用VIP功能或资源，若您需要导出视频，还请升级会员。",
            type: "error",
            customClass: "vip-toast",
          });
      }
      this.classifyItems(this.IsVipSprites.data);
    });
  },
  beforeDestroy() {
    this.$bus.off("rmAbandon", this.rmAbandon);
  },
  methods: {
    ...mapMutations({
      setCommonvipMaterial: 'resources/setCommonvipMaterial',
      setComponyvipMaterial: 'resources/setComponyvipMaterial'
    }),
    buyVip() {
      let a = document.createElement("a");
      a.target = "_blank";
      a.href = "/workplace/pricing";
      a.click();
    },
    specialType(info) {
      if (info.artword) {
        return "artword";
      } else if (info.type === "uploadVideoNUM") {
        return "video";
      } else if (info.type === 'sceneEffect') {
        return 'sceneEffect';
      }
      return "";
    },
    getInfoForPrice(info) {
      let payType = info.payType;
      if (info.specialType === "artword") {
        payType = 4;
      } else if (info.specialType === "video") {
        payType = 4;
      }

      return payType;
    },
    onRemoveItem () {
      this.classifyItems(this.IsVipSprites.data);
    },
    classifyItems(list) {
      let sortFn = (f, s) => {
        let a = f.id;
        let b = s.id;
        return a > b ? 1 : b > a ? -1 : 0;
      };
      list = [...list];
      this.$emit("emitRightsNumber", list.length);
      let temp = [];
      this.TOOL.sprites.forEach((scene) => {
        let p = list.filter((item) => item.scenesId === scene.id) || [];
        p = p.sort(sortFn);
        temp.push(p);
      });

      // 带有特殊的scenesId的数据
      const listSpecialScenesId =
        list.filter(
          (item) =>
            !item.scenesId || (item.scenesId && item.scenesId.length < 36)
        ) || [];
      let gs = listSpecialScenesId;

      let temp2 = [...gs];
      temp.forEach((item) => {
        temp2 = [...temp2, ...item];
      });
      let videoData = temp2.find((v) => v.videoNum && v.sprites);
      let videos = [];
      if (videoData && videoData.sprites) {
        videos = videoData.sprites.map((v) => {
          let video = {
            ...videoData,
          };
          delete video.sprites;
          video = {
            ...video,
            ...v,
          };
          return video;
        });

        // let _vn = videoData.videoNum;
        let _dn = this.UserEquity.draftVideo;
        // if (_vn > 3) {
        //   _dn = 3;
        // }
        videos.splice(0, _dn);
        videos.forEach((v, i) => {
          if (this.UserEquity.draftVideo === 1) {
            v.limitType = i < 2 ? 'person' : 'company';
          } else {
            v.limitType = 'company';
          }
        })
      }
      videos = videos.filter(v => v.scenesId) || [];
      let noVideoList =
        temp2.filter(
          (item) =>
            item.price == null &&
            item.type !== "uploadVideoNUM" &&
            !item.removed
        ) || [];

      noVideoList = this.addSceneEffects(noVideoList);
      let vips = [...videos, ...noVideoList];
      let pays = temp2.filter((item) => item.price != null && !item.removed);
      let removeds = temp2.filter((item) => item.removed);
      if (this.UserMsg.payForFont == 1) {
        pays = pays.filter((v) => v.fileType != 15);
        vips = vips.filter((v) => v.fileType != 15);
      }
      if (this.UserMsg.payForMaterial == 1) {
        pays = pays.filter((v) => v.fileType == 15);
        vips = vips.filter((v) => v.fileType == 15);
      }

      this.parts[0].items = vips;
      this.parts[1].items = pays;
      this.parts[2].items = removeds;

      this.setCommonvipMaterial(null);
      this.setComponyvipMaterial(null);
      vips.forEach((value) => {
        value.specialType = this.specialType(value);
        value.payType = this.getInfoForPrice(value);
        if (value.payType === 4) {
          // 个人vip专属
          this.setCommonvipMaterial(value);
        } else if (value.payType === 6) {
          // 企业vip专属
          this.setComponyvipMaterial(value);
        }
      });

      // this.$nextTick(() => {
      //   let comps = [].concat(this.$refs.vipRef);
      //   comps.forEach((v) => {
      //     v.setFileType();
      //   })
      // })
    },
    isEmpty() {
      return this.parts.every((v) => v.items && !v.items.length);
    },
    getFoldTitle(num = 0, title) {
      return `共<span style="color: red;">${num}</span>个素材`;
    },
    toggleFold(item) {
      item.foldOpened = !item.foldOpened;
    },
    async goPopMsg(name) {
      console.log('mbb');
      // 对未加载的场景页进行加载
      this.$bus.emit("loadingAllScenes", "start");
      for (let i = 0; i < this.TOOL.sprites.length; i++) {
        const scenes = this.TOOL.sprites[i];
        if (scenes.fromJsonLoadingState < 1 && scenes.unLoadData.json) {
          await this.TOOL.selectScenes(scenes);
          await scenes.fromJson(
            scenes.unLoadData.json,
            this.TOOL.clientWidth / scenes.unLoadData.resolutionWidth,
            true
          );
        }

        //初始化一些动画资源
        await scenes.activeAnimation();
      }
      this.$bus.emit("loadingAllScenes", "end");

      console.log('Modal_vue9090909', this.type);
      this.$bus.emit("Modal_vue", {
        name: "delVip",
        data: {
          type: "record",
          popMsg: name,
          type: this.type
        },
      });
    },
    async rmAbandon() {
      // 对未加载的场景页进行加载
      // this.$bus.emit("loadingAllScenes", "start");
      // for (let i = 0; i < this.TOOL.sprites.length; i++) {
      //   const scenes = this.TOOL.sprites[i];
      //   if (scenes.fromJsonLoadingState < 1 && scenes.unLoadData.json) {
      //     await this.TOOL.selectScenes(scenes);
      //     await scenes.fromJson(
      //       scenes.unLoadData.json,
      //       this.TOOL.clientWidth / scenes.unLoadData.resolutionWidth,
      //       true
      //     );
      //   }
      //   //初始化一些动画资源
      //   await scenes.activeAnimation()
      // }
      // this.$bus.emit("loadingAllScenes", "end");
      // let items = this.parts[2].items;
      // this.TOOL.sprites.forEach((scene) => {
      //   scene.sprites.forEach((sprite) => {
      //     let has = items.some(v => v.id === sprite.id);
      //     has = has && has.length;
      //     if (has) {
      //     }
      //   });
      // });
      // this.delStepFS();
      // this.parts[2].items.forEach((v, i) => {
      //   let comp = this.$refs.abandonRef[i];
      //   this.$refs.abandonRef[i].locate({ isDel: true });
      //   let isBg = comp.info.type === 'bg';
      //   if (isBg) {
      //     this.rmBg(comp.info.scenesId);
      //   }
      // });
    },
    rmBg(id) {
      let scenesData = this.TOOL.getScenesIdData(id);
      let bgOpts = {
        // 设置场景背景
        resourceId: null, // 背景资源id
        fileType: null, // 背景资源type
        type: "Color",
        data: {
          color: "#FFFFFF",
          blur: 0,
          opacity: 1,
        },
        zoomActive: false,
      };

      this.$store.commit("del_vipSprites", {
        id: "BG-" + scenesData.id,
      });
      scenesData.setBackground(bgOpts, null, true);
    },
    delStepFS() {
      let items = this.parts[2].items;
      return;
      // this.delStep = 1;
      let listFS = [];
      for (let j = 0; j < items.length; j++) {
        let sprite = items[j],
          scenesData,
          thisFS;

        switch (sprite.type) {
          case "sprite":
            thisFS = () => {
              this.TOOL.removeSprite(sprite.id);
            };
            break;
          case "scenes":
            thisFS = () => {
              if (this.TOOL.sprites.length === 1) {
                this.TOOL.addScenes(null, null, true).then((scenes) => {
                  this.TOOL.removeScenes(sprite.id);
                  this.TOOL.selectScenes(scenes).then((data) => {
                    // this.TOOL.moveScenesTo(scenes.id, scenesIndex);
                  });
                });
              } else {
                this.TOOL.removeScenes(sprite.id);
              }
            };
            break;
          case "ScenesSound":
            scenesData = this.TOOL.getScenesIdData(sprite.id);
            thisFS = () => {
              scenesData.clearSound();
            };
            break;
          case "AllSound":
            thisFS = () => {
              this.TOOL.clearSoundRecord({ undo: true });
            };
            break;
          case "TOOLsound":
            thisFS = () => {
              this.TOOL.setSound({}, true);
            };
            break;
          case "bg":
            scenesData = this.TOOL.getScenesIdData(sprite.scenesId);
            let bgOpts = {
              // 设置场景背景
              resourceId: null, // 背景资源id
              fileType: null, // 背景资源type
              type: "Color",
              data: {
                color: "#FFFFFF",
                blur: 0,
                opacity: 1,
              },
              zoomActive: false,
            };

            thisFS = () => {
              this.$store.commit("del_vipSprites", {
                id: "BG-" + scenesData.id,
              });
              scenesData.setBackground(bgOpts, null, true);
            };
            break;
          case "groupSprites":
            scenesData = this.TOOL.getScenesIdData(sprite.scenesId);
            let groupSprites = scenesData.getGroupData(sprite.id).sprites;
            thisFS = () => {
              for (let c = 0; c < groupSprites.length; c++) {
                this.TOOL.removeSprite(groupSprites[c].id);
              }
            };
            break;
        }
        listFS.push(thisFS);
      }
      let mergePromise = (ajaxArray) => {
        var data = [];
        var sequence = Promise.resolve();
        ajaxArray.forEach(function (item) {
          sequence = sequence.then(item).then(function (res) {
            data.push(res);
            return data;
          });
        });

        return sequence;
      };

      mergePromise(listFS);
    },
    addSceneEffects (list) {
      const sceneList = getVipSceneEffects(this.TOOL.sprites) || [];
      // const copy = [...list];
      // copy.forEach((v, i) => {
      //   const next = copy[i + 1];
      //   if (!next || (next && v.scenesId !== next.scenesId)) {
      //     const sceneItem = sceneList.find(item => item.scenesId === v.scenesId);
      //     const sceneEffects = list.filter(v => v && v.type === 'sceneEffect') || [];
      //     const exist = sceneEffects.some(item => item.scenesId === v.scenesId);
      //     const l = lastIndex(list, v.scenesId, 'scenesId');
      //     sceneItem && !exist && list.splice(l + 1, 0, sceneItem);
      //   }
      // });

      let outputList = [];
      this.TOOL.sprites.forEach(v => {
        let part = list.filter(item => item.scenesId === v.id) || [];
        const sceneEffectItem = sceneList.find(item => item.scenesId === v.id);
        if (sceneEffectItem) {
          part = [...part, sceneEffectItem];
        }
        outputList = [...outputList, ...part];
      });
      const f = list.filter(v => {
        const inNewList = outputList.some(item => item === v);
        return !inNewList;
      }) || [];
      outputList = [...f, ...outputList];

      return outputList;
      function lastIndex(arr, val, key) {
        const len = arr.length;
        for (let i = len - 1; i >= 0; i--) {
          const v = arr[i];
          if (v[key] === val) {
            return i;
          }
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.rights {
  cursor: default;
  & * {
    box-sizing: border-box;
  }
  & > ul {
    overflow: auto;
  }
}
.panel {
  overflow: hidden;
  width: 320px;
  height: 0;
  padding: 0 12px;
  margin: auto;
  background: #f9faff;
  border-radius: 4px;
  // transition-property: height;
  transition-duration: 0.3s;

  &.opened {
    max-height: 360px;
    overflow-y: scroll;
    height: auto;
    padding: 12px;
  }
}
.risk-item {
  margin-top: 10px;
  &:first-of-type {
    margin-top: 0;
  }
}
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px 10px;
  font-size: 12px;
}
.title-text {
  cursor: pointer;
}
.title-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 64px;
  min-height: 24px;
  color: #fff;
  background: #3569fd;
  border-radius: 4px;
  cursor: pointer;
}
.shim {
  width: 100%;
  height: 20px;
  opacity: 0;
}
.upgrade {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  margin-top: 20px;
  color: #a87213;
  background: linear-gradient(135deg, #ffecd1 0%, #f8d88e 53%, #e3c086 100%);
  border-radius: 0 0 4px 4px;
  cursor: pointer;
}
.title-arrow {
  display: inline-block;
  width: 16px;
  height: 9px;
  margin-left: 8px;
  background-image: url(../../../assets/risk/fold-arrow.svg);
  transition-duration: 0.3s;

  &.active {
    transform: rotate(180deg);
  }
}
.bold {
  font-weight: bold;
}
.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & .figure {
    width: 147px;
    height: 100px;
    margin-top: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/riskDrop/rights.vue